import React, { forwardRef, useRef } from 'react';
import { useBpDesignTheme } from '../../setup';
import { Paper, PaperProps } from '../Paper/Paper';
import { styled } from '../../styles';
import { useComponentApiProvider } from '../../utils/useComponentApi';
import { onVisibleInViewPort } from '../../utils/useIntersectionObserver';

export interface HighlightableApi {
  highlight(): void;
}

export const HighlightablePaper = forwardRef<HighlightableApi, Omit<PaperProps, 'ref'>>((props, ref) => {
  const elRef = useRef<HTMLDivElement>(null);
  const { tokens } = useBpDesignTheme();
  useComponentApiProvider<HighlightableApi, HighlightableApi>(
    ref,
    () => ({
      highlight: () => {
        const element = elRef.current;
        if (element) {
          onVisibleInViewPort(element, (thisElement) => {
            thisElement.animate(
              [
                {}, // initial keyframe. Takes initial styles
                {
                  outlineColor: tokens.colorSecondaryContainer,
                  backgroundColor: tokens.paletteDeepBlue95
                },
                {
                  borderColor: tokens.colorPrimary,
                  outlineColor: tokens.colorSecondaryContainer,
                  backgroundColor: tokens.paletteDeepBlue95
                },
                {} // end keyframe. Back to initial styles
              ],
              {
                duration: 800,
                iterations: 1,
                easing: 'ease-out'
              }
            );
          });
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }),
    []
  );
  return <StyledPaper {...props} className={`outlined ${props.className || ''}`} ref={elRef} />;
});

const StyledPaper = styled(Paper)`
    outline: 5px solid transparent;

`;
